import { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MediaThumbnailProps {
  src: string;
  alt: string;
  className?: string;
}

/** Square library thumbnail with a muted fallback when the image fails to load. */
export function MediaThumbnail({ src, alt, className }: MediaThumbnailProps) {
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [src]);

  return (
    <div
      className={cn(
        'bg-muted flex aspect-square w-full items-center justify-center overflow-hidden rounded-md border',
        className,
      )}
    >
      {errored ? (
        <ImageOff className="text-muted-foreground size-6" aria-hidden />
      ) : (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="size-full object-cover"
          onError={() => setErrored(true)}
        />
      )}
    </div>
  );
}
